import { SCREENS, REDUX_ACTIONS, GAME_ID } from '../../data/constants';

const initState = { currentScreen: SCREENS.LOADING };

const isSavedGameStateBroken = payload => payload.roundPlay && payload.screen &&
    payload.roundPlay.answeredCharacters.length === 2 &&
    payload.screen.currentScreen === SCREENS.CROWD;

const screenReducer = (state = initState, { type, payload, gameId }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    // change screen according to action payload
    case REDUX_ACTIONS.CHANGE_SCREEN:
      return { currentScreen: payload };

    case REDUX_ACTIONS.LOAD_LOCALLY_SAVED_LEVEL: {
      const savedState = payload.screen ? payload.screen : {};

      if (isSavedGameStateBroken(payload)) { // AQUA-30250
        savedState.currentScreen = SCREENS.STANDARD_VIEW;
      }

      return {
        ...state,
        ...savedState,
      };
    }

    case REDUX_ACTIONS.ROUND_END:
      return {
        ...initState,
      };

    default:
      return state;
  }
};

export default screenReducer;
